import { connect } from 'react-redux';
import { usersListActions } from 'Actions/index';
import Users from 'Components/Users';

function mapStatetoProps(state){
    const { usersList, totalRecords, currentPage, loading } = state.usersList;
    const { exportUsersData, exportUsersTotalRecords, exportUsersId, exportStatus } = state.exportUserData;
    const { profile } = state;
    return{
        profile: profile.permission && JSON.parse(profile.permission),
        usersList: usersList,
        totalRecords: totalRecords,
        currentPage: currentPage,
        loading,
        exportUsersData,
        exportUsersTotalRecords,
        exportUsersId,
        exportStatus,
    } 
}

const mapDispatchtoProps = {
    fetchUsersList: usersListActions.fetchUsersList,
    exportUsers: usersListActions.exportUsers,
    exportUsersStatus: usersListActions.exportUsersStatus,
}

export default connect(mapStatetoProps,mapDispatchtoProps)(Users)